import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"text-xl font-bold text-primary-500 mb-2.5\">III. Medical History 病歴</p><p class=\"text-darkgray-800\">Check the box if you have or had in the past any of the following: </p><p class=\"mb-5 text-xs text-darkgray-800\">現在かかっている病気、または過去にかかった病気がある場合は、下記のボックスにチェックを入れてください。</p><div class=\"mb-4 space-y-1 text-darkgray-800\"><p class=\"font-bold\">Your illnesses/conditions</p></div>", 4)
const _hoisted_6 = {
  key: 0,
  class: "text-right col-span-full"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col-span-full lg:col-span-6" }
const _hoisted_9 = { class: "col-span-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 font-bold" }, "Medical History/ご本人の病歴", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Right now, this illness/condition is...", -1)
const _hoisted_12 = { class: "flex justify-between lg:flex-row flex-col flex-wrap gap-2.5" }
const _hoisted_13 = { class: "col-span-full" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 font-bold" }, "Family Medical History", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Is there anyone in your family who has/had this same illness/condition?", -1)
const _hoisted_16 = { class: "flex justify-between lg:flex-row flex-col flex-wrap gap-2.5" }

import RadioGroup from '@/components/inputs/RadioGroup.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import { ref, watch } from 'vue';
import MedicalService from "@/classes/MedicalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'MedicalHistory',
  props: {
    form: {
        type: Object,
        required: true
    },
    illnesses: {
        type: Array,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: true
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)
const illnessStatus = ref(MedicalService.getIllnessStatus());

const addIllness = () => {
    item.value.illness_history.push({
        is_checked: false,
        description: null,
        status: null,
        family_member: [],
    })
}

const remove = (index : number) => {
    item.value.illness_history.splice(index, 1);
}

const inMedicalHistory = (item: any, val : string): boolean => {
    return item.family_member.findIndex((member:any) => member == val) != -1
}

const addRemoveMedicalHistory = (item: any, val : string):void => {
    const index = item.family_member.findIndex((member:any) => member == val)
    const hasNone = inMedicalHistory(item, 'none');

    if(index != -1){
        item.family_member.splice(index, 1);
    } else {
        if(val == 'none'){
            item.family_member = [];
        }

        if(!hasNone){
            item.family_member.push(val);
        }
    }
    
}

const medicalHistoryOption = [
    { 
        label: 'None', value: 'none'
    },
    { 
        label: 'Father/父', value: 'father'
    },
    { 
        label: 'Mother/母', value: 'mother'
    },
    { 
        label: 'Sibling/きょうだい', value: 'sibling'
    },
]

// watch(
//       () => item.value.last_checkup.where,
//       (val) => {
//         if(val == 'Shinagawa Diagnostic and Preventive Care') {
//             item.value.last_checkup.other = null
//         }
//       },
//       { immediate: true }
//     );

watch(
      () => item.value.family_hospital_doctor,
      (val) => {
        if(val == 'No') {
            item.value.specify_family_hospital = null
        }
      },
      { immediate: true }
    );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.illness_history, (illness, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid grid-cols-1 p-5 mb-2 lg:grid-cols-12 gap-x-8 gap-y-5 bg-primary-50 rounded-2xl lg:p-7",
        key: index
      }, [
        (index >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!__props.disableInputs)
                ? (_openBlock(), _createElementBlock("small", {
                    key: 0,
                    onClick: ($event: any) => (remove(index)),
                    class: "text-sm text-red-500 cursor-pointer"
                  }, "Remove", 8, _hoisted_7))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(MultiselectInput, {
            disabled: __props.disableInputs,
            id: `${illness}-${index}`,
            modelValue: illness.description,
            "onUpdate:modelValue": [($event: any) => ((illness.description) = $event),  (value) => (illness.is_checked = value != null)],
            placeholder: "Choose illness/condition / 病名",
            options: __props.illnesses
          }, null, 8, ["disabled", "id", "modelValue", "onUpdate:modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(RadioGroup, {
              isDisabled: __props.disableInputs,
              id: `radio-${illness}-${index}`,
              name: `radio-${illness}-${index}`,
              modelValue: illness.status,
              "onUpdate:modelValue": ($event: any) => ((illness.status) = $event),
              options: illnessStatus.value
            }, null, 8, ["isDisabled", "id", "name", "modelValue", "onUpdate:modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(medicalHistoryOption, (i) => {
              return _createVNode(CheckboxInput, {
                key: i.value,
                id: i.label,
                label: i.label,
                rounded: false,
                "text-color": "text-darkgray-800",
                disabled: inMedicalHistory(illness, 'none') && i.value != 'none',
                isChecked: inMedicalHistory(illness, i.value),
                onClick: ($event: any) => (addRemoveMedicalHistory(illness, i.value))
              }, null, 8, ["id", "label", "disabled", "isChecked", "onClick"])
            }), 64))
          ])
        ])
      ]))
    }), 128)),
    (!__props.disableInputs)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: addIllness,
          class: "mt-2 text-sm font-bold transition cursor-pointer text-primary-500 hover:text-primary-700 w-fit"
        }, "Add another +"))
      : _createCommentVNode("", true)
  ]))
}
}

})